// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");

function useMlsStatusCheck() {
  let mlsStatusCheckFeatureEnabled = FeaturesV3.useFeatureFlipper("CheckPropertyStatusOnMLS") === "on";
  let chapterHasPreference = UserSession.useChapterPreference("MlsComingSoon");
  if (mlsStatusCheckFeatureEnabled) {
    return chapterHasPreference !== "OFF";
  } else {
    return false;
  }
}

function useAnonymousBroadcastPropertiesEnabled() {
  let anonymousBroadcastPropertiesFeatureEnabled = FeaturesV3.useFeatureFlipper("AnonymousBroadcastProperties") === "on";
  let chapterHasPreference = UserSession.useChapterPreference("AnonymousBroadcastProperties");
  if (anonymousBroadcastPropertiesFeatureEnabled) {
    return chapterHasPreference !== "OFF";
  } else {
    return false;
  }
}

exports.useMlsStatusCheck = useMlsStatusCheck;
exports.useAnonymousBroadcastPropertiesEnabled = useAnonymousBroadcastPropertiesEnabled;
/* FeaturesV3 Not a pure module */
